"use client";

import { createSharedConfigService } from "@shared/lib/config";
import { toCamel } from "@shared/utils";
import { handleCopyClipboard } from "@ubud-ui/react-ui-kit";
import { toast } from "sonner";
import { CustomDataProvider, customFetch } from "./rest-data-provider";

const dataProvider = (url: string): CustomDataProvider => ({
  custom: async ({ method, url: path, payload, headers, options }) => {
    const headerOptions = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    };

    if (options && options.token) {
      headerOptions["Authorization"] = `Bearer ${options.token}`;
    }

    const response = await customFetch(`${url}${path}`, {
      method,
      body: payload ? JSON.stringify(payload) : undefined,
      headers: headerOptions,
      ...options,
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const combinedErrors = [data?.error_description, data?.hint].join(", ");
      const message = data?.message || combinedErrors || response.statusText || "Unknown error";

      const traceId = response.headers.get("Trace-Id") || response.headers.get("trace-id") || response.headers.get("Trace-ID");

      if (traceId) {
        toast.error("Terjadi Kesalahan", {
          description: message + " (Trace ID: " + traceId + ")",
          dismissible: false,
          action: {
            label: "Salin Trace ID",
            onClick: () => handleCopyClipboard(traceId || ""),
          },
        });
      } else {
        toast.error("Terjadi Kesalahan", {
          description: message,
          dismissible: false,
          action: {
            label: "Tutup",
            onClick: () => toast.dismiss(),
          },
        });
      }

      if (response.status === 401) {
        const redirectUrl = window.location.pathname;

        window.location.href = redirectUrl ? "/api/naco/login?redirect_url=" + redirectUrl : "/api/naco/login";
      }

      throw new Error(message);
    }

    return toCamel(data);
  },
});

export const createRestDataProviderClient = () => {
  const configService = createSharedConfigService();

  return dataProvider(configService.config.apiUrl || "http://localhost:8000");
}